import { BusinessType } from "../types/legacyBusiness.types";
import type { BaseBusiness } from "../types/legacyBusiness.types";
import logo from "../../assets/images/finca-ecologica-don-juan/logo.png";
import placeholder from "../../assets/images/placeholder.webp";
import logoApiZaid from "../../assets/images/api-zaid/api-zaid-logo.jpeg";
import logoCafeLaMarcela from "../../assets/images/cafe-la-marcela/cafe-la-marcela-logo.webp";
import logoFincaZamora from "../../assets/images/finca-zamoraFallas/logo.jpg";
import logoApiG from "../../assets/images/api-g/logo.jpg";
import logoJessy from "../../assets/images/reposteria-jessy/logo-jessy.png";
import videoApiZaid from "../../assets/images/api-zaid/videos/api-zaid.mp4";
import videoApiG from "../../assets/images/api-g/videos/api-g.mp4";
import videoApiG1 from "../../assets/images/api-g/videos/apig1.mp4";
import videoCafeLaMarcela from "../../assets/images/cafe-la-marcela/videos/cafe-la-marcela.mp4";
import videoFincaEcologicaDonJuan from "../../assets/images/finca-ecologica-don-juan/videos/finca-ecologica-don-juan.mp4";
import videoReposteriaJessy from "../../assets/images/reposteria-jessy/videos/reposteria-jessy.mp4";

export const businessesData: BaseBusiness[] = [
  {
    id: "lacteos-don-juan",
    logo,
    backgroundImage: logo,
    type: BusinessType.MILK,
    products: [
      {
        id: "queso-semiduro",
        image: require("../../assets/images/finca-ecologica-don-juan/products/queso-semiduro.webp"),
        presentations: [
          { weight: "500g", price: "₡2.100" },
          { weight: "1kg", price: "₡4.000" },
        ],
      },
      {
        id: "queso-pasteurizado",
        image: require("../../assets/images/finca-ecologica-don-juan/products/queso-pastorizado.webp"),
        presentations: [
          { weight: "500g", price: "₡2.200" },
          { weight: "3kg", price: "₡12.600" },
        ],
      },
      {
        id: "queso-mozzarella",
        image: require("../../assets/images/finca-ecologica-don-juan/products/queso-motzzarella.webp"),
        presentations: [
          { weight: "500g", price: "₡3.000" },
          { weight: "3kg", price: "₡16.500" },
        ],
      },
      {
        id: "queso-parmesano",
        image: require("../../assets/images/finca-ecologica-don-juan/products/queso-motzzarella-rallado.webp"),
        presentations: [
          { weight: "200g", price: "₡1.400" },
          { weight: "1kg", price: "₡5.500" },
          { weight: "3kg", price: "₡11.500" },
        ],
      },
      {
        id: "queso-palmito",
        image: require("../../assets/images/finca-ecologica-don-juan/products/queso-palmito.webp"),
        price: "₡5.000/kg",
      },
      {
        id: "queso-ricotta",
        image: require("../../assets/images/finca-ecologica-don-juan/logo.png"),
        presentations: [
          { weight: "200g", price: "₡1.400" },
          { weight: "1kg", price: "₡5.500" },
          { weight: "6kg", price: "₡30.000" },
        ],
      },
      {
        id: "natilla-casera",
        image: require("../../assets/images/finca-ecologica-don-juan/products/natilla-casera.webp"),
        presentations: [
          { weight: "200g", price: "₡1.000" },
          { weight: "500g", price: "₡1.400" },
        ],
      },
      {
        id: "yogurt-artesanal",
        image: require("../../assets/images/finca-ecologica-don-juan/products/yogurt-sabores.webp"),
        presentations: [
          { flavor: "Fresa", price: "₡250" },
          { flavor: "Mora", price: "₡250" },
          { flavor: "Coco", price: "₡250" },
          { flavor: "Piña", price: "₡250" },
          { flavor: "Kiwi", price: "₡250" },
        ],
      },
      {
        id: "miel-artesanal",
        image: require("../../assets/images/finca-ecologica-don-juan/products/miel-artesanal.webp"),
        price: "₡5.000",
      },
    ],
    tours: [
      { id: "tour-vacas", image: "images/tour-vacas.jpg", price: "$12 / 2 personas", duration: "3-4 horas" },
      { id: "tour-mariposa", image: "images/tour-mariposa.jpg", price: "$9.99 / 2 personas" },
      { id: "tour-agua", image: "images/tour-agua.jpg", price: "$6.55 / 2 personas" },
      { id: "tour-senderos", image: "images/senderos.jpg", price: "$6.99 / 2 personas" },
      { id: "tour-miel", image: "images/tour-miel.jpg", price: "$12 / 2 personas" },
    ],
    soda: {
      image: require("../../assets/images/finca-ecologica-don-juan/photos/soda.jpg"),
    },
    artesanias: {},
    videos: [
      {
        id: "lacteos-don-juan-presentacion",
        url: videoFincaEcologicaDonJuan,
        thumbnail: logo,
      },
    ],
    images: [
      { id: "bosque", url: require("../../assets/images/finca-ecologica-don-juan/photos/bosque.jpg"), name: "Bosque" },
      { id: "dueno-finca", url: require("../../assets/images/finca-ecologica-don-juan/photos/dueno.jpg"), name: "Dueño de la finca" },
      { id: "entrada-sendero", url: require("../../assets/images/finca-ecologica-don-juan/photos/entrada-sendero.jpg"), name: "Entrada al sendero" },
      { id: "entrevista", url: require("../../assets/images/finca-ecologica-don-juan/photos/entrevista.jpg"), name: "Entrevistas" },
      { id: "sendero-ecologico", url: require("../../assets/images/finca-ecologica-don-juan/photos/sendero.jpg"), name: "Sendero ecológico" },
      { id: "entrada-soda", url: require("../../assets/images/finca-ecologica-don-juan/photos/soda-entrada.jpg"), name: "Entrada de la soda" },
      { id: "soda-don-juan", url: require("../../assets/images/finca-ecologica-don-juan/photos/soda.jpg"), name: "Soda Don Juan" },
      { id: "zonas-recreacion", url: require("../../assets/images/finca-ecologica-don-juan/photos/zonas-recreacion.jpg"), name: "Zonas de recreación" },
      { id: "senderos-ecologicos", url: require("../../assets/images/finca-ecologica-don-juan/photos/senderos.jpg"), name: "Senderos Ecológicos" },
      { id: "tour-finca", url: require("../../assets/images/finca-ecologica-don-juan/photos/tour.jpg"), name: "Tour en la finca" },
    ],
    location: { lat: 8.843077314715543, lng: -83.02542138927491 },
    contactInfo: {
      email: "fincaecologicadonjuan@gmail.com",
      phone: "+506 8810-6090",
      address: "Finca Don Juan, 1km norte de la plaza de deportes",
    },
    socialMedia: {
      whatsapp: "+506 8810-6090",
    },
  },
  {
    id: "cafe-la-marcela",
    logo: logoCafeLaMarcela,
    backgroundImage: logoCafeLaMarcela,
    type: BusinessType.COFFE,
    products: [
      {
        id: "cafe-la-marcela-250g-premio-primero",
        image: require("../../assets/images/cafe-la-marcela/products/cafe.jpg"),
        price: "₡3.500",
      },
      {
        id: "cafe-la-marcela-250g-blanco",
        image: require("../../assets/images/cafe-la-marcela/products/blanco.jpg"),
        price: "₡3.500",
      },
      {
        id: "cafe-la-marcela-250g-negro",
        image: require("../../assets/images/cafe-la-marcela/products/negro.jpg"),
        price: "₡3.500",
      },
      {
        id: "cafe-la-marcela-160g-negro",
        image: require("../../assets/images/cafe-la-marcela/products/negro-160.jpg"),
        price: "₡2.000",
      },
      {
        id: "cafe-la-marcela-250g-plateado",
        image: require("../../assets/images/cafe-la-marcela/products/plateado.jpg"),
        price: "₡2.000",
      },
    ],
    videos: [
      {
        id: "cafe-la-marcela-presentacion",
        url: videoCafeLaMarcela,
        thumbnail: logoCafeLaMarcela,
      },
    ],
    images: [
      { id: "premio-feria", url: require("../../assets/images/cafe-la-marcela/photos/premio.jpg"), name: "Primer Lugar de Feria de Café Zona Alta de Sabalito" },
      { id: "entrevista-publicitaria", url: require("../../assets/images/cafe-la-marcela/photos/entrevista.jpg"), name: "Entrevista para video publicitario" },
      { id: "encargada", url: require("../../assets/images/cafe-la-marcela/photos/entrevistas.jpg"), name: "Entrevista con encargada" },
    ],
    location: { lat: 8.89036245776725, lng: -82.77323665040109 },
    contactInfo: {
      email: "mileidyalfaro311@gmail.com",
      phone: "+506 8635-7243",
      address: "Las Mellizas de Sabalito, Coto Brus. 300 metros norte de la iglesia católica. A mano derecha, casa color crema.",
    },
    socialMedia: {
      whatsapp: "+506 8635 7243",
    },
  },
  {
    id: "api-zaid",
    logo: logoApiZaid,
    backgroundImage: logoApiZaid,
    type: BusinessType.HONEY,
    products: [
      { id: "miel-700g", image: require("../../assets/images/api-zaid/products/700g-miel.jpg"), price: "₡5.000" },
      { id: "miel-panal", image: [require("../../assets/images/api-zaid/products/miel-panal.jpg")], price: "₡5.800" },
      { id: "miel-1000g-botella", image: require("../../assets/images/api-zaid/products/botella-1000g.jpg"), price: "₡5.000" },
      { id: "miel-215g-botella", image: require("../../assets/images/api-zaid/products/botella-215g.jpg"), price: "₡2.000" },
    ],
    videos: [
      {
        id: "api-zaid-presentacion",
        url: videoApiZaid,
        thumbnail: logoApiZaid,
      },
    ],
    images: [
      { id: "entrevistas", url: require("../../assets/images/api-zaid/photos/entrevistas.jpg"), name: "Entrevistas" },
      { id: "miel-general", url: require("../../assets/images/api-zaid/photos/miel-general.jpg"), name: "Productos de miel en general" },
      { id: "encargada", url: require("../../assets/images/api-zaid/photos/entrevista.jpg"), name: "Entrevista con encargada" },
      { id: "producto", url: require("../../assets/images/api-zaid/photos/miel.jpg"), name: "Presentación de producto" },
    ],
    location: { lat: 8.89036245776725, lng: -82.77323665040109 },
    contactInfo: {
      email: "mileidyalfaro311@gmail.com",
      phone: "+506 8635-7243",
      address: "Las Mellizas de Sabalito, Coto Brus. 300 metros norte de la iglesia católica. A mano derecha, casa color crema.",
    },
    socialMedia: {
      whatsapp: "+506 8635 7243",
      instagram: "https://www.instagram.com/mielapi_zaid/?igsh=MTlmYmh2MThoanJ0ZA%3D%3D#",
    },
  },
  {
    id: "api-g-apiarios-gil",
    logo: logoApiG,
    backgroundImage: logoApiG,
    type: BusinessType.HONEY,
    products: [
      {
        id: "goteros-mariolita",
        image: require("../../assets/images/api-g/products/goteros-mariolita.jpeg"),
        presentations: [
          { weight: "20g", price: "₡3.500" },
          { weight: "40g", price: "₡7.000" },
        ],
      },
      {
        id: "goteros-propoleo",
        image: require("../../assets/images/api-g/products/goteros-de-propoleo.jpeg"),
        presentations: [
          { weight: "15g", price: "₡3.500" },
          { weight: "35g", price: "₡6.500" },
        ],
      },
      { id: "miel-liquida-275g", image: require("../../assets/images/api-g/products/miel-liquida-275g.jpeg"), price: "₡3.000" },
      { id: "miel-liquida-1400g", image: require("../../assets/images/api-g/products/miel-liquida-1400g.jpeg"), price: "₡9.000" },
      { id: "miel-liquida-1000g", image: require("../../assets/images/api-g/products/miel-liquida-1000g.jpeg"), price: "₡7.000" },
      { id: "miel-cremada-250g", image: require("../../assets/images/api-g/products/miel-cremada-250g.jpeg"), price: "₡4.000" },
      { id: "cera-operculo-1kg", image: require("../../assets/images/api-g/products/cera-de-operaculo.jpeg"), price: "₡30.000" },
      { id: "saquito-empaque-miel", image: require("../../assets/images/api-g/products/saquito-miel.jpeg"), price: "₡600" },
      {
        id: "reinas-geneticas-cordovan-carniola",
        image: require("../../assets/images/api-g/products/reinas-geneticas-cordovan-y-carniola.jpeg"),
        presentations: [
          { flavor: "Apareada", price: "₡12.000" },
          { flavor: "Virgen", price: "₡5.000" },
          { flavor: "Alvéolo", price: "₡3.500" },
        ],
      },
      { id: "cajas-estandar-langstroth", image: require("../../assets/images/api-g/products/cajas-langstroth.jpeg"), price: "₡10.000" },
      { id: "cajas-abejas-sin-aguijon", image: require("../../assets/images/api-g/products/cajas-para-abejas.jpeg"), price: "Desde ₡30.000" },
      { id: "atrayente-abejas-sin-aguijon", image: require("../../assets/images/api-g/products/atrayente-para-abejas.jpeg"), price: "₡10.000" },
    ],
    tours: [
      {
        id: "tour-apiario",
        image: [
          require("../../assets/images/api-g/tour/portada-tour.jpeg"),
          require("../../assets/images/api-g/tour/tour-explicacion.jpg"),
          require("../../assets/images/api-g/tour/tour-explicacion1.jpeg"),
          require("../../assets/images/api-g/tour/tour-explicacion2.jpeg"),
          require("../../assets/images/api-g/tour/tour-explicacion3.jpeg"),
          require("../../assets/images/api-g/tour/tour-explicacion4.jpeg"),
          require("../../assets/images/api-g/tour/tour-explicacion5.jpeg"),
          require("../../assets/images/api-g/tour/tour-explicacion6.jpeg"),
        ],
        price: "Consultar precio",
      },
      { id: "charlas-apicultura", image: placeholder, price: "$8 por hora", duration: "1-4 horas" },
    ],
    images: [
      { id: "apertura-colmena", url: require("../../assets/images/api-g/photos/apertura-colmena.jpg"), name: "Apertura de colmena" },
      { id: "apiario", url: require("../../assets/images/api-g/photos/api.jpg"), name: "Apiario" },
      { id: "colmenas", url: require("../../assets/images/api-g/photos/colmenas.jpg"), name: "Colmena" },
      { id: "entrevistas", url: require("../../assets/images/api-g/photos/entrevistas.jpg"), name: "Entrevistas" },
      { id: "interior-colmena", url: require("../../assets/images/api-g/photos/interior-colmera.jpg"), name: "Interior de colmena" },
      { id: "miel-cruda", url: require("../../assets/images/api-g/photos/miel-comena.jpg"), name: "Miel Cruda con Panal" },
      { id: "ponel", url: require("../../assets/images/api-g/photos/ponel.jpg"), name: "Ponel" },
      { id: "productos-generales", url: require("../../assets/images/api-g/photos/productos-general.jpg"), name: "Productos generales" },
      { id: "sendero-apicola", url: require("../../assets/images/api-g/photos/sendero-api.jpg"), name: "Sendero apícola" },
      { id: "entrada-sendero", url: require("../../assets/images/api-g/photos/sendero-entrada.jpg"), name: "Entrada al sendero" },
      { id: "sendero", url: require("../../assets/images/api-g/photos/sendero.jpg"), name: "Sendero" },
      { id: "tour-explicado", url: require("../../assets/images/api-g/photos/tour-explicacion.jpg"), name: "Tour explicado" },
      { id: "visita-apiario", url: require("../../assets/images/api-g/photos/visita-api.jpg"), name: "Visita al apiario" },
      { id: "funcionamiento-colmena", url: require("../../assets/images/api-g/photos/colmena-explicacion.jpg"), name: "Explicación del funcionamiento de una colmena" },
      { id: "abeja-reina", url: require("../../assets/images/api-g/photos/abejas-reina.jpg"), name: "Explicación sobre la abeja reina" },
      { id: "tour-apiario-portada", url: require("../../assets/images/api-g/tour/portada-tour.jpeg"), name: "Tour en el apiario" },
      { id: "tour-apiario-explicacion", url: require("../../assets/images/api-g/tour/tour-explicacion.jpg"), name: "Explicación durante el tour" },
      { id: "tour-apiario-explicacion-1", url: require("../../assets/images/api-g/tour/tour-explicacion1.jpeg"), name: "Visita educativa al apiario" },
      { id: "tour-apiario-explicacion-2", url: require("../../assets/images/api-g/tour/tour-explicacion2.jpeg"), name: "Grupo participante del tour" },
      { id: "tour-apiario-explicacion-3", url: require("../../assets/images/api-g/tour/tour-explicacion3.jpeg"), name: "Participantes con equipo apícola" },
      { id: "tour-apiario-explicacion-4", url: require("../../assets/images/api-g/tour/tour-explicacion4.jpeg"), name: "Experiencia educativa con abejas" },
      { id: "tour-apiario-explicacion-5", url: require("../../assets/images/api-g/tour/tour-explicacion5.jpeg"), name: "Demostración en el apiario" },
      { id: "tour-apiario-explicacion-6", url: require("../../assets/images/api-g/tour/tour-explicacion6.jpeg"), name: "Observación de una colmena" },
    ],
    videos: [
      { id: "api-g-presentacion", url: videoApiG, thumbnail: logoApiG },
      { id: "api-g-presentacion-2", url: videoApiG1, thumbnail: logoApiG },
    ],
    location: { lat: 8.891351189758629, lng: -82.7945733260498 },
    contactInfo: {
      email: "apiarios.g@gmail.com",
      phone: "+506 8794-4945",
      address: "50 metros este de Agroservicio La Poderosa y 50 metros sur, La Lucha de Sabalito, Puntarenas",
    },
    socialMedia: {
      whatsapp: "+506 8794-4945",
      facebook: "https://www.facebook.com/people/Api-G/100094106944689/?rdid=KDaw4iwqpSBc1g97&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1FGjCgjQkx%2F",
      instagram: "https://www.instagram.com/api_.g?igsh=cmI5cG0zZnBzbmpt",
    },
  },
  {
    id: "finca-zamora-fallas",
    logo: logoFincaZamora,
    backgroundImage: logoFincaZamora,
    type: BusinessType.COFFE,
    products: [
  {
    id: "finca-zamora-cafe-altura",
    image: placeholder,
    presentations: [
      {
        weight: "250g",
        price: "₡2.500",
      },
      {
        weight: "500g",
        price: "₡5.000",
      },
      {
        weight: "1kg",
        price: "₡10.000",
      },
    ],
  },
],
    tours: [
      {
        id: "tour-completo",
        image: require("../../assets/images/finca-zamoraFallas/photos/sendero-la-montana.jpg"),
        price: "$50 por persona",
        duration: "3-4 horas",
      },
    ],
    images: [
      { id: "finca-certificada", url: require("../../assets/images/finca-zamoraFallas/photos/finca.jpg"), name: "Finca Certificada" },
      { id: "plantacion-cafe", url: require("../../assets/images/finca-zamoraFallas/photos/cafetal.jpg"), name: "Plantación de café" },
      { id: "cafe-floreado", url: require("../../assets/images/finca-zamoraFallas/photos/cafe-floreado.jpg"), name: "Café floreado" },
      { id: "cafe-recoger", url: require("../../assets/images/finca-zamoraFallas/photos/cafe-para-recoger.jpeg"), name: "Café para recoger" },
      { id: "duenos-finca", url: require("../../assets/images/finca-zamoraFallas/photos/duenos.jpg"), name: "Dueños de la finca" },
      { id: "estudiantes-una", url: require("../../assets/images/finca-zamoraFallas/photos/estudiantes-una.jpeg"), name: "Estudiantes de la Universidad Nacional de visita por la finca" },
      { id: "comunidades-indigenas", url: require("../../assets/images/finca-zamoraFallas/photos/indigenas.jpeg"), name: "Comunidades indígenas trasladadas a la finca en temporada de cosecha" },
      { id: "recolecta-indigena", url: require("../../assets/images/finca-zamoraFallas/photos/indigenas-cosecha.jpeg"), name: "Comunidades indígenas en recolecta de café" },
      { id: "inicio-cosecha", url: require("../../assets/images/finca-zamoraFallas/photos/inicio-cosella.jpeg"), name: "Inicio de la cosecha" },
      { id: "logo-finca", url: require("../../assets/images/finca-zamoraFallas/logo.jpg"), name: "Logo de la finca" },
      { id: "mata-cafe-cosecha", url: require("../../assets/images/finca-zamoraFallas/photos/mata-cafe-cosecha.jpeg"), name: "Mata de café en cosecha" },
      { id: "mata-cafe", url: require("../../assets/images/finca-zamoraFallas/photos/mata-cafe.jpg"), name: "Mata de café" },
      { id: "plantacion-semillas", url: require("../../assets/images/finca-zamoraFallas/photos/plantacion-semilla-cafe.jpeg"), name: "Plantación - semillas" },
      { id: "proceso-produccion", url: require("../../assets/images/finca-zamoraFallas/photos/produccion.jpeg"), name: "Proceso de producción" },
      { id: "productor-cafe", url: require("../../assets/images/finca-zamoraFallas/photos/productor-cafe.jpeg"), name: "Productor de café" },
      { id: "recolecta-cafe", url: require("../../assets/images/finca-zamoraFallas/photos/recolecta.jpg"), name: "Recolecta de café" },
      { id: "sendero-principal", url: require("../../assets/images/finca-zamoraFallas/photos/sendero.jpg"), name: "Sendero principal" },
      { id: "sendero-montana", url: require("../../assets/images/finca-zamoraFallas/photos/sendero-la-montana.jpg"), name: "Sendero La Montaña" },
      { id: "pasillo-sendero", url: require("../../assets/images/finca-zamoraFallas/photos/sendero-pasillo.jpg"), name: "Pasillo del sendero" },
      { id: "bandera-azul", url: require("../../assets/images/finca-zamoraFallas/photos/bandera-azul-ecologica.jpeg"), name: "Bandera Azul Ecológica" },
    ],
    videos: [],
    location: { lat: 8.865747908947986, lng: -82.88051262725706 },
    contactInfo: {
      email: "fincazamorayfallas@gmail.com",
      phone: "+506 8825-8659",
      address: "San Miguel de Sabalito, Coto Brus, Puntarenas",
    },
    socialMedia: {
      whatsapp: "+506 8825 8659",
    },
  },
  {
    id: "mieles-santa-lucia",
    logo: placeholder,
    backgroundImage: placeholder,
    type: BusinessType.HONEY,
    products: [
      { id: "mieles-santa-lucia-botella-350ml", image: placeholder, price: "₡2.700" },
      { id: "mieles-santa-lucia-botella-750ml", image: placeholder, price: "₡5.500" },
      { id: "propoleo-25ml", image: placeholder, price: "₡5.000" },
    ],
    images: [
      { id: "colmena", url: require("../../assets/images/mieles-santa-lucia/photos/colmena.jpg"), name: "Colmena de abejas" },
      { id: "entrevista-publicidad", url: require("../../assets/images/mieles-santa-lucia/photos/entrevista-publicidad.jpg"), name: "Entrevista brindada para video publicitario" },
      { id: "logo-empresa", url: require("../../assets/images/mieles-santa-lucia/photos/mieles-santa-lucia-logo.jpeg"), name: "Logo de la empresa" },
      { id: "envasado-miel", url: require("../../assets/images/mieles-santa-lucia/photos/mieles.jpg"), name: "Envasado de la miel para su posterior venta" },
      { id: "colmenas-mariola", url: require("../../assets/images/mieles-santa-lucia/photos/panal-mariola.jpg"), name: "Colmenas de abejas mariola" },
      { id: "entrada-colmena-mariola", url: require("../../assets/images/mieles-santa-lucia/photos/panal.jpg"), name: "Entrada de la colmena de abejas mariola" },
    ],
    videos: [
      {
        id: "mieles-santa-lucia-presentacion",
        url: placeholder,
        thumbnail: placeholder,
      },
    ],
    location: { lat: 8.884404134646255, lng: -82.81861105198229 },
    contactInfo: {
      email: "luciafallas2004@gmail.com",
      phone: "+506 8515-9413",
      address: "500 metros al suroeste del Colegio Jorge Volio Jiménez",
    },
    socialMedia: {
      whatsapp: "+506 8515 9413",
    },
  },
  {
    id: "pasteleria-reposteria-jessy",
    logo: logoJessy,
    backgroundImage: logoJessy,
    type: BusinessType.BAKERY,
    products: [
      { id: "queque-normal", image: require("../../assets/images/reposteria-jessy/products/queque-normal.jpeg"), price: "Varía según decoración" },
      { id: "queque-humedo", image: require("../../assets/images/reposteria-jessy/products/queque-humedo.jpeg"), price: "Varía según decoración" },
      { id: "queque-zanahoria", image: require("../../assets/images/reposteria-jessy/products/queque-zanahoria.jpeg"), price: "Varía según decoración" },
      { id: "queque-borracho", image: require("../../assets/images/reposteria-jessy/products/queque-borracho.jpeg"), price: "Varía según decoración" },
      { id: "queque-chocolate", image: require("../../assets/images/reposteria-jessy/products/queque-chocolate.jpeg"), price: "Varía según decoración" },
      { id: "queque-chocolate-con-chocolate", image: require("../../assets/images/reposteria-jessy/products/chocolate-con-chocolate.jpeg"), price: "Varía según decoración" },
      { id: "queque-chocolate-humedo", image: require("../../assets/images/reposteria-jessy/products/chocolate-humedo.jpeg"), price: "Varía según decoración" },
      { id: "carlota-melocoton", image: require("../../assets/images/reposteria-jessy/products/carlota.jpeg"), price: "Varía según decoración" },
      { id: "carlota-fresa", image: require("../../assets/images/reposteria-jessy/products/carlota-fresa.webp"), price: "Varía según decoración" },
      { id: "carlota-frutas", image: require("../../assets/images/reposteria-jessy/products/carlota-frutas.jpeg"), price: "Varía según decoración" },
      { id: "torta-fria", image: require("../../assets/images/reposteria-jessy/products/torta-fria.jpeg"), price: "Varía según decoración" },
      { id: "torta-napolitana", image: require("../../assets/images/reposteria-jessy/products/napolitana.jpeg"), price: "Varía según decoración" },
      { id: "tiramisu", image: require("../../assets/images/reposteria-jessy/products/tiramisu.jpeg"), price: "Varía según decoración" },
      { id: "torta-chilena", image: require("../../assets/images/reposteria-jessy/products/torta-chilena.jpg"), price: "Varía según decoración" },
      { id: "tres-leches", image: require("../../assets/images/reposteria-jessy/products/tres-leches.jpeg"), price: "Varía según decoración" },
      { id: "torta-churchill", image: require("../../assets/images/reposteria-jessy/products/torta-churchill.jpeg"), price: "Varía según decoración" },
      { id: "torta-baileys", image: require("../../assets/images/reposteria-jessy/products/torta-baileys.jpeg"), price: "Varía según decoración" },
      { id: "torta-whisky", image: require("../../assets/images/reposteria-jessy/products/torta-whiskey.jpeg"), price: "Varía según decoración" },
      { id: "torta-chilena-cereal", image: require("../../assets/images/reposteria-jessy/products/torta-chilena-cereal.jpeg"), price: "Varía según decoración" },
      { id: "explosion-de-chocolate", image: require("../../assets/images/reposteria-jessy/products/explosion-chocolate.jpeg"), price: "Varía según decoración" },
      { id: "cheesecake", image: require("../../assets/images/reposteria-jessy/products/cheesecake.jpeg"), price: "Varía según decoración" },
      { id: "selva-negra", image: require("../../assets/images/reposteria-jessy/products/selva-negra.jpeg"), price: "Varía según decoración" },
      { id: "torta-opera", image: require("../../assets/images/reposteria-jessy/products/torta-opera.jpeg"), price: "Varía según decoración" },
      { id: "tres-leches-pina-colada", image: require("../../assets/images/reposteria-jessy/products/tres-leches-pina-colada.jpeg"), price: "Varía según decoración" },
      { id: "tronco", image: require("../../assets/images/reposteria-jessy/products/tronco.jpeg"), price: "Varía según decoración" },
      { id: "torta-rossana", image: require("../../assets/images/reposteria-jessy/products/torta-rossana.jpeg"), price: "Varía según decoración" },
      { id: "queques-navidenos", image: require("../../assets/images/reposteria-jessy/products/queque-navidad.jpeg"), price: "Desde ₡7.500 - ₡30.000 según tamaño" },
      { id: "bocadillos-para-eventos", image: require("../../assets/images/reposteria-jessy/products/bocadillos-eventos.jpeg"), price: "Consultar precio" },
    ],
    images: [
      { id: "queque-abeja", url: require("../../assets/images/reposteria-jessy/photos/abejaqueque.jpeg"), name: "Queque de abeja" },
      { id: "cupcakes", url: require("../../assets/images/reposteria-jessy/photos/cupcake.jpeg"), name: "Cupcakes" },
      { id: "entrevistas", url: require("../../assets/images/reposteria-jessy/photos/entrevistas.jpg"), name: "Entrevistas" },
      { id: "tres-leches", url: require("../../assets/images/reposteria-jessy/photos/general.jpg"), name: "Tres leches" },
      { id: "postre", url: require("../../assets/images/reposteria-jessy/photos/postre.jpg"), name: "Postre" },
      { id: "torta-chilena", url: require("../../assets/images/reposteria-jessy/photos/productos-general.jpg"), name: "Torta Chilena" },
      { id: "queque-eventos", url: require("../../assets/images/reposteria-jessy/photos/queque.jpeg"), name: "Queque para eventos" },
      { id: "queque-aniversario", url: require("../../assets/images/reposteria-jessy/photos/queque1.jpeg"), name: "Queque para aniversario" },
      { id: "queque-15", url: require("../../assets/images/reposteria-jessy/photos/queque15anos.jpeg"), name: "Queque para 15 años" },
      { id: "queque-tres-pisos", url: require("../../assets/images/reposteria-jessy/photos/queque2.jpeg"), name: "Queque de tres pisos" },
      { id: "queque-boda-1", url: require("../../assets/images/reposteria-jessy/photos/queque-boda.jpeg"), name: "Queque para Boda" },
      { id: "queque-boda-2", url: require("../../assets/images/reposteria-jessy/photos/queque-boda1.jpeg"), name: "Queque para Boda" },
      { id: "queque-cumple", url: require("../../assets/images/reposteria-jessy/photos/queque-cumpleanos.jpeg"), name: "Queque para Cumpleaños" },
      { id: "navideno-pequeno", url: require("../../assets/images/reposteria-jessy/photos/queque-navida.jpeg"), name: "Queque Navideño Pequeño" },
      { id: "navideno-grande", url: require("../../assets/images/reposteria-jessy/photos/queque-navida1.jpeg"), name: "Queque Navideño Grande" },
      { id: "navideno-mediano", url: require("../../assets/images/reposteria-jessy/photos/queque-navideno.jpeg"), name: "Queque Navideño Mediano" },
      { id: "queques", url: require("../../assets/images/reposteria-jessy/photos/queques.jpeg"), name: "Queques" },
      { id: "mesas-eventos", url: require("../../assets/images/reposteria-jessy/photos/queques-eventos.jpeg"), name: "Mesas para eventos" },
      { id: "torta-chilena-foto", url: require("../../assets/images/reposteria-jessy/photos/torta-chilena.jpg"), name: "Torta Chilena" },
      { id: "tres-leches-foto", url: require("../../assets/images/reposteria-jessy/photos/tres-leches.jpg"), name: "Tres Leches" },
    ],
    videos: [
      {
        id: "reposteria-jessy-presentacion",
        url: videoReposteriaJessy,
        thumbnail: placeholder,
      },
    ],
    location: { lat: 8.891351189758629, lng: -82.7945733260498 },
    contactInfo: {
      email: "jychinchilla88@gmail.com",
      phone: "+506 8794-4995",
      address: "50 metros este de Agroservicio La Poderosa y 50 metros sur, La Lucha de Sabalito, Puntarenas",
    },
    socialMedia: {
      facebook: "https://www.facebook.com/share/1FwCHxNMAe/",
      whatsapp: "+506 8794-4995",
    },
  },
];
